import { CONTACT_US_PAGE_URL } from "@/constants/index"
import { getTranslations } from "@/components/PartsViewer/v2/localization"
import { useTranslation } from "next-i18next"
import { useSelector } from "react-redux"
import { selectGenericState } from "@/store/features/genericSlice"

const ErrorFallbackUI = () => {
  const { t } = useTranslation("common")
  const { errorSorryText, errorTextTwo, errorContactText } = getTranslations(t)
  const { globalConfig } = useSelector(selectGenericState)
  const { internationalization: { language = "en" } = {} } = globalConfig

  return (
    <div className="fallback-wrapper d-flex flex-column w-100 h-100">
      <div className="error-message">
        <div className="text-section">
          <div className="line-first">{errorSorryText}</div>
          <div className="questions">
            {errorTextTwo}
            <a
              href={`/${language}${CONTACT_US_PAGE_URL}`}
              target="_blank"
              rel="noreferrer"
            >
              {errorContactText}
            </a>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ErrorFallbackUI
